module.exports = __webpack_public_path__ + "static/media/phil.e0d3e941.jpeg";